import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CSketchLegendeComponent } from './c-sketch-legende.component';
import { MarqueursLegendeModule } from 'src/app/pipes/marqueurs-legende/marqueurs-legende.module';



@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    MarqueursLegendeModule
  ],
  declarations: [
    CSketchLegendeComponent,
  ],
  exports: [
    CSketchLegendeComponent,
  ],
})
export class CSketchLegendeModule { }
